export default __webpack_public_path__ + "static/media/whatsapp-logo.b6e468aa.png";